module.exports = __webpack_public_path__ + "static/img/left.27bf4e0b.png";